export default {"src":"/_next/static/media/arc.df303d60.svg","height":18,"width":278,"blurWidth":0,"blurHeight":0};